var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"foot-t"},[_vm._v(" 指导单位：苏州市商务局 | 苏州高新区商务局        建设单位：苏州海贸通跨境电子商务产业服务有限公司 ")]),_c('div',{staticClass:"foot-c"},[_vm._v(" 组织单位： 市商务局 | 市财政局 | 市市场监督管理局 | 苏州海关 | 国家外汇管理局苏州市分局 | 国家税务总局苏州市税务局 | 市邮政管理局 ")]),_c('div',{staticClass:"foot-b"},[_vm._v("备案号：苏ICP备2023006083号-1")])])])
}]

export { render, staticRenderFns }